import React from 'react'
import Stock from 'components/custom/Highcharts/Stock'

class ScheduleTrendlineChart extends React.Component {
  render() {
    const {
      report
    } = this.props

    const maxEnd = report.data && report.data.length > 0 && report.data.reduce(function (a, b) {
      return a.data.length > 0 && b.data.length > 0 && (a.data[a.data.length - 1][0] > b.data[b.data.length - 1][0]) ? a : b;
    }, report.data[0]);

    const options = {
      xAxis: {
        plotLines: [{
          value: Date.now(),
          color: 'red',
          dashStyle: 'shortdash',
          width: 1,
        }],
        plotBands: [{
          from: Date.now(),
          to: maxEnd && maxEnd.data.length > 0 && maxEnd.data[maxEnd.data.length - 1][0],
          color: 'rgba(119,185,0, 0.2)',
        }]
      },
    }

    return (
      <div>
        {report &&
          <Stock
            title={report.title}
            data={report.data}
            additionalOptions={options}
          />}
      </div>
    );
  }
}

export default ScheduleTrendlineChart